/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./history-tab.vue?vue&type=template&id=c1f02560&scoped=true&"
import script from "./history-tab.vue?vue&type=script&lang=ts&"
export * from "./history-tab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f02560",
  null
  
)

export default component.exports